'use strict';
import * as $j_app$002eapi$002e$002dIn$002dMaintenance$002dData from "./app.api.-In-Maintenance-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$$anon$22(evaluator$28) {
  this.Lapp_api_UnauthenticatedAppUpdate$$anon$22__f_evaluator$4 = null;
  this.Lapp_api_UnauthenticatedAppUpdate$$anon$22__f_evaluator$4 = evaluator$28;
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$$anon$22 as $c_Lapp_api_UnauthenticatedAppUpdate$$anon$22 };
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$22;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$$anon$22() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$$anon$22 as $h_Lapp_api_UnauthenticatedAppUpdate$$anon$22 };
$h_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_UnauthenticatedAppUpdate$$anon$22__f_evaluator$4.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dIn$002dMaintenance$002dData.$c_Lapp_api_InMaintenanceData) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$22.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_UnauthenticatedAppUpdate$$anon$22 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$$anon$22, "app.api.UnauthenticatedAppUpdate$$anon$22", ({
  Lapp_api_UnauthenticatedAppUpdate$$anon$22: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$$anon$22 as $d_Lapp_api_UnauthenticatedAppUpdate$$anon$22 };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$$anon$22.js.map
